import { useTranslations } from 'next-intl';
import styled from 'styled-components';
import {
  Button,
  Eyebrow,
  HeroBackground,
  HeroTitle,
  Lead,
  SectionContainer,
} from '@/components/ui';
import { up } from '@/themes';
import BrandCollage from './brand-collage';
import HeroSearch from './hero-search';

/*
 * Clipped sideways only (the tilted cards may poke past the edge), so the
 * search suggestions can drop below the hero; z-index keeps them above the
 * next section.
 */
const Wrapper = styled.section`
  isolation: isolate;
  overflow-x: clip;
  position: relative;
  z-index: 2;
`;

const Layout = styled(SectionContainer)`
  display: grid;
  gap: 56px;
  grid-template-columns: minmax(0, 1fr);
  padding-bottom: 48px;
  padding-top: 64px;

  ${up.sm} {
    padding-bottom: 64px;
    padding-top: 96px;
  }

  ${up.lg} {
    align-items: center;
    gap: 64px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

const Copy = styled.div`
  max-width: 672px;
  /* Above the collage, for the suggestion list on small screens. */
  position: relative;
  z-index: 1;
`;

const Title = styled(HeroTitle)`
  margin-top: 16px;
`;

const Description = styled(Lead)`
  margin-top: 24px;
`;

const Search = styled(HeroSearch)`
  margin-top: 32px;
`;

const Actions = styled.div`
  margin-top: 16px;
`;

/**
 * Home hero: the page's h1, the brand search and a collage of brand cards.
 * Nothing here animates in: the h1 is the largest contentful paint.
 */
const Hero = ({ brands }) => {
  const t = useTranslations('home');

  return (
    <Wrapper data-section="hero">
      <HeroBackground />
      <Layout>
        <Copy>
          <Eyebrow>{t('eyebrow')}</Eyebrow>
          <Title>{t('title')}</Title>
          <Description $large>{t('lead')}</Description>
          <Search />
          <Actions>
            <Button $size="pill" href="/buy">
              {t('browseAll')}
            </Button>
          </Actions>
        </Copy>
        <BrandCollage brands={brands} label={t('collageLabel')} />
      </Layout>
    </Wrapper>
  );
};

export default Hero;
